import React, { useEffect, useState } from 'react';
import useSeo from '../hooks/useSeo';
import { useLanguage } from '../context/LanguageContext';

import HeroSection from '../components/sections/HeroSection';
import TrustStripSection from '../components/sections/TrustStripSection';
import ServicesSection from '../components/sections/ServicesSection';
import WhyUsSection from '../components/sections/WhyUsSection';
import BeforeAfterSection from '../components/sections/BeforeAfterSection';
import ProcessSection from '../components/sections/ProcessSection';
import PackagesSection from '../components/sections/PackagesSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import TeamSection from '../components/sections/TeamSection';
import FAQSection from '../components/sections/FAQSection';
import ContactSection from '../components/sections/ContactSection';

const API_URL = import.meta.env.VITE_API_URL || (typeof window !== 'undefined' ? window.location.origin : '');

const detectLangByLocation = () => {
  if (typeof navigator === 'undefined') return 'en';
  const navLang = (navigator.language || 'en').toLowerCase();
  if (navLang.startsWith('tr')) return 'tr';
  if (navLang.startsWith('ru')) return 'ru';
  if (navLang.startsWith('nb') || navLang.startsWith('nn') || navLang.startsWith('no')) return 'no';
  if (navLang.startsWith('de')) return 'de';
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (tz.includes('Istanbul')) return 'tr';
    if (tz.includes('Moscow') || tz.includes('Yekaterinburg')) return 'ru';
    if (tz.includes('Oslo')) return 'no';
    if (tz.includes('Berlin')) return 'de';
  } catch (_e) {}
  return 'en';
};

export default function Home() {
  const { currentLanguage: lang, changeLanguage } = useLanguage();
  useSeo('home', lang);
  const [clinic, setClinic] = useState(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && !localStorage.getItem('crystal-language')) {
      const detected = detectLangByLocation();
      changeLanguage(detected);
    }
  }, [changeLanguage]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await fetch(`${API_URL}/api/settings/public?group=contact`);
        if (!res.ok) return;
        const payload = await res.json();
        if (!cancelled && payload?.data) setClinic(payload.data);
      } catch (_e) {}
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="home-page">
      <HeroSection clinic={clinic} />
      <TrustStripSection />
      <ServicesSection />
      <WhyUsSection />
      <BeforeAfterSection />
      <ProcessSection />
      <PackagesSection />
      <TestimonialsSection />
      <TeamSection />
      <FAQSection />
      <ContactSection clinic={clinic} />
    </div>
  );
}
